import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BasePage } from 'src/pages/base.page';
import { NotificacoesModel } from 'projects/core/src/lib/core/model/NotificacoesModel';
import { NotificacoesViewModel } from './NotificacoesViewModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { AlertController, ToastController, NavController } from '@ionic/angular';
import { FirebaseWrapper } from 'projects/core/src/lib/core/FirebaseWrapper';

@Component({
  selector: 'notificacoes-page',
  templateUrl: 'notificacoes.page.html',
  styleUrls: ['notificacoes.page.scss']
})
export class NotificacoesPage extends BasePage {
  constructor(
    public router: Router,
    public alertController: AlertController,
    public toastCtrl: ToastController,
    public navCtrl: NavController) {
    super(router)
  }

  emRequisicao: Boolean = false

  notificacoesModel: NotificacoesModel
  notificacoesViewModel: NotificacoesViewModel
  alertComponent: AlertComponent
  primeiraRequisicao: Boolean = false
  enableWalletRecommendation = false

  async ngOnInit() {
    this.inicializarVariaveis()
    this.obtemOpcoesNotificacao()
    this.enableWalletRecommendation = await this.notificacoesViewModel.hasAPlanWalletRecommendationEnabled()
  }

  inicializarVariaveis() {
    this.notificacoesModel = new NotificacoesModel()
    this.notificacoesViewModel = new NotificacoesViewModel()
    this.notificacoesViewModel.setContext(this)
  }

  changeOption() {
    if (this.primeiraRequisicao) {
      this.enviaOpcaoSelecionada()
    }
  }

  async enviaOpcaoSelecionada() {
    try {
      this.emRequisicao = true
      await this.notificacoesViewModel.deletaOpcaoNotificacao()
      await this.notificacoesViewModel.enviaOpcaoNotificacao(this.notificacoesModel)
    } catch (e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
    }
    setTimeout(() => {
      this.emRequisicao = false
    }, 1000)
  }

  async obtemOpcoesNotificacao() {
    try {
      await this.notificacoesViewModel.obtemOpcoesNotificacao()
    } catch (e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT, () => {
        this.navCtrl.pop()
      })
    }
  }

  setOpcoesNotificacoes(notificacoesModel: NotificacoesModel) {
    this.notificacoesModel = notificacoesModel
    this.configuraTopicsFirebase()
    // Tempo para realizar o binding nos componentes
    setTimeout(() => {
      this.primeiraRequisicao = true
    }, 1000)
  }

  configuraTopicsFirebase() {
    new FirebaseWrapper().configuraTopicsFirebase(this.notificacoesModel)
  }

  mensagemSucessoAlteracao(message: string) {
    this.showToast(message)
  }

  mensagemFalhaAlteracao(message: string) {
    this.showToast(message)
  }

  async showToast(message: string) {
    let toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
}
